module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_takeover-ba0e0b9695a45005ea6870569a3c7f08.svg";